import classNames from 'classnames';
import { defineMessage, useIntl } from 'react-intl';
import setDenaliAttribute from '../../utils/setDenaliAttribute';
import ProgressBarStep from './ProgressBarStep';
import styles from './styles/styles.module.scss';

type PagedProgressBarProps = {
  className?: string;
  index: number;
  total: number;
  onClick?: (index: number) => void;
  stepDurationMs?: number;
};

const PagedProgressBar = ({ className, index, total, onClick, stepDurationMs }: PagedProgressBarProps) => {
  const intl = useIntl();
  const stepButtonLabel = defineMessage({
    defaultMessage: 'Option {optionNumber}'
  });

  return (
    <div {...setDenaliAttribute('PagedProgressBar')} className={classNames(styles.progressBar, className)}>
      {Array(total)
        .fill('')
        .map((_, i) => {
          return (
            <ProgressBarStep
              key={`step-${i}`}
              animationMs={i === index ? stepDurationMs : 0}
              ariaLabel={intl.formatMessage(stepButtonLabel, { optionNumber: i + 1 })}
              complete={i <= index}
              onClick={onClick ? () => onClick(i) : undefined}
            />
          );
        })}
    </div>
  );
};

export default PagedProgressBar;
